module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block, _vm.getBlockModifiers()]
  }, [(!_vm.isMobile) ? _c('div', {
    class: [_vm.block] + '-header',
    domProps: {
      "innerHTML": _vm._s(_vm.data.text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isMobile && _vm.data.textMobile) ? _c('div', {
    class: [_vm.block] + '-header',
    domProps: {
      "innerHTML": _vm._s(_vm.data.textMobile)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.subText) ? _c('h1', {
    class: [_vm.block] + '-subHeader',
    domProps: {
      "innerHTML": _vm._s(_vm.data.subText)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.links) ? _c('div', {
    class: [_vm.block] + '-links'
  }, _vm._l((_vm.data.links), function(link) {
    return _c('div', {
      class: [_vm.block] + '-linkContainer'
    }, [(link.route) ? _c('router-link', {
      class: [_vm.block] + '-link',
      attrs: {
        "to": link.route
      }
    }, [_vm._v(_vm._s(link.linkText)), (link.icon) ? _c('icon-gb', {
      class: [_vm.block + '-icon m-inline'],
      attrs: {
        "name": 'spotin-com-' + link.icon
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (link.callback) ? _c('div', {
      class: [_vm.block] + '-link',
      on: {
        "click": _vm.callback
      }
    }, [_vm._v(_vm._s(link.linkText)), (link.icon) ? _c('icon-gb', {
      class: [_vm.block + '-icon m-inline'],
      attrs: {
        "name": 'spotin-com-' + link.icon
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isMobile && link.linkSubText) ? _c('span', {
      class: [_vm.block] + '-linkSubText'
    }, [_vm._v(_vm._s(link.linkSubText))]) : _vm._e()], 1)
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c192a0","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/combinedBlocks/HeaderFull.vue
// module id = 496
// module chunks = 0